module.exports = __webpack_public_path__ + "img/truck.4dbe2ef2.svg";